<!-- app-subdomain-creators\src\layouts\DefaultLayout.vue -->

<template>
  <div
    v-if="appSettingsStore.isLoaded"
    class="layout-root"
  >
    <!-- <CartComponent :isOpen="isCartOpen" @close="toggleCart" /> -->
    <div
      v-if="isCartOpen"
      class="fixed inset-0 bg-black opacity-60 z-40"
    />
    <!-- Cart Component -->
    <CartComponent
      :is-open="isCartOpen"
      @close="toggleCart"
    />

    <div>
      <TransitionRoot
        as="template"
        :show="sidebarOpen"
      >
        <Dialog
          as="div"
          class="relative z-20 lg:hidden"
          @close="sidebarOpen = false"
        >
          <TransitionChild
            as="template"
            enter="transition-opacity ease-linear duration-300"
            enter-from="opacity-0"
            enter-to="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leave-from="opacity-100"
            leave-to="opacity-0"
          >
            <div class="fixed inset-0 bg-gray-900/80" />
          </TransitionChild>

          <div class="fixed inset-0 flex">
            <TransitionChild
              as="template"
              enter="transition ease-in-out duration-300 transform"
              enter-from="-translate-x-full"
              enter-to="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leave-from="translate-x-0"
              leave-to="-translate-x-full"
            >
              <DialogPanel class="relative mr-16 flex w-full max-w-xs flex-1">
                <TransitionChild
                  as="template"
                  enter="ease-in-out duration-300"
                  enter-from="opacity-0"
                  enter-to="opacity-100"
                  leave="ease-in-out duration-300"
                  leave-from="opacity-100"
                  leave-to="opacity-0"
                >
                  <div
                    class="absolute left-full top-0 flex w-16 justify-center pt-5"
                  >
                    <button
                      type="button"
                      class="-m-2.5 p-2.5"
                      @click="sidebarOpen = false"
                    >
                      <span class="sr-only">Close sidebar</span>
                      <XMarkIcon
                        class="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </TransitionChild>
                <!-- Sidebar component, swap this element with another sidebar if you like -->
                <div
                  class="app-scroll z-30 flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10"
                >
                  <div class="flex h-16 shrink-0 items-center">
                    <img
                      class="h-12 w-auto"
                      :src="memberLogoSrc"
                      alt="Member UI Placeholder"
                      @error="handleMemberLogoError"
                    >
                  </div>
                  <nav class="flex flex-1 flex-col">
                    <ul
                      role="list"
                      class="flex flex-1 flex-col gap-y-7"
                    >
                      <li>
                        <ul
                          role="list"
                          class="-mx-2 space-y-1"
                        >
                          <li
                            v-for="item in navigation"
                            :key="item.name"
                          >
                            <router-link :to="item.to" />
                          </li>
                        </ul>
                      </li>
  
                      <li class="mt-auto">
                        <a
                          href="#"
                          class="group -mx-2 flex gap-x-3 rounded-md p-2 text-sm font-semibold leading-6 text-gray-400 hover:bg-gray-800 hover:text-white"
                        >
                          <Cog6ToothIcon
                            class="h-6 w-6 shrink-0"
                            aria-hidden="true"
                          />
                          Settings
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </TransitionRoot>

      <!-- Static sidebar for desktop -->
      <div
        class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col relative lg:transition-all lg:duration-300 lg:ease-in-out lg:rounded-r-3xl"
        :class="[
          sidebarEditingHover ? 'shadow-[inset_0_0_0_3px_rgb(168,85,247)]' : '',
          desktopSidebarCollapsed ? 'lg:-translate-x-full lg:opacity-0 lg:pointer-events-none' : 'lg:translate-x-0 lg:opacity-100',
        ]"
        :style="{ backgroundColor: sidebarBgColor }"
        @mouseenter="sidebarEditingHover = true"
        @mouseleave="sidebarEditingHover = false"
      >
        <div 
          class="absolute bg-white/70 border backdrop-blur-sm border-zinc-200 shadow-xl w-[55px] h-96 
                top-[30%] left-[280px] rounded-2xl 
                flex flex-col gap-6 items-center py-6"
          :class="sidebarEditingHover ? 'block' : 'hidden'"
        >
          <!-- ADD PRODUCT -->
          <div class="relative group flex justify-center">
            <PlusCircleIcon
              class="h-9 text-zinc-700 hover:text-zinc-500 cursor-pointer"
              @click="openModal"
            />

            <!-- Tooltip -->
            <div
              class="absolute left-10 top-1/2 -translate-y-1/2
                    bg-black/80 text-white text-xs
                    px-3 py-1 rounded-lg shadow-xl backdrop-blur-sm
                    whitespace-nowrap
                    opacity-0 group-hover:opacity-100
                    transition-opacity duration-200"
            >
              Add Product
            </div>
          </div>

          <!-- GLOBAL APP SETTINGS -->
          <div class="relative group flex justify-center">
            <Cog6ToothIcon
              class="h-8 text-zinc-700 hover:text-zinc-500 cursor-pointer"
              @click="openGlobalAppSettings"
            />

            <div
              class="absolute left-10 top-1/2 -translate-y-1/2
                    bg-black/80 text-white text-xs
                    px-3 py-1 rounded-lg shadow-xl backdrop-blur-sm
                    whitespace-nowrap
                    opacity-0 group-hover:opacity-100
                    transition-opacity duration-200"
            >
              Global App Settings
            </div>
          </div>

          <!-- COLOR PICKER -->
          <div class="relative group flex justify-center">
            <button
              class="w-8 h-8 rounded-full shadow flex items-center justify-center
                    bg-white hover:bg-zinc-100 cursor-pointer"
              @click="openSidebarSettings"
            >
              <img
                src="@/assets/media/images/platforma-color-selector.png"
                class="w-8 h-8"
              >
            </button>

            <div
              class="absolute left-10 top-1/2 -translate-y-1/2
                    bg-black/80 text-white text-xs
                    px-3 py-1 rounded-lg shadow-xl backdrop-blur-sm
                    whitespace-nowrap
                    opacity-0 group-hover:opacity-100
                    transition-opacity duration-200"
            >
              App Colors
            </div>
          </div>
        </div>




        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="app-scroll flex grow flex-col gap-y-5 overflow-y-auto px-6 pb-4 pt-3">
          <div class="relative group">
            <img
              class="h-12 w-auto cursor-pointer transition-opacity duration-300 hover:opacity-75"
              :src="memberLogoSrc"
              alt="Member UI Placeholder"
              @error="handleMemberLogoError"
            >
            <!-- Hover overlay with camera icon -->
            <div
              class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 transition-opacity duration-300 group-hover:opacity-100 cursor-pointer rounded-lg"
            >
              <div class="relative">
                <div class="h-10 opacity-75 rounded-full ">
                  <CameraIcon
                    class="h-6 text-white cursor-pointer"
                    @click="triggerImageUpload"
                  />
                </div>
      
                <!-- Tooltip -->
                <span
                  class="absolute top-8 w-32 mx-auto left-1/2 transform -translate-x-1/2 bg-gray-900 text-white text-xs rounded-lg px-2 py-1"
                >
                  Add/Change logo
                </span>
              </div>
            </div>

            <!-- Hidden file input -->
            <input
              ref="fileInput"
              type="file"
              class="hidden"
              @change="updateLogo"
            >
          </div>


          <nav class="flex flex-1 flex-col">
            <ul
              role="list"
              class="flex flex-1 flex-col gap-y-7"
            >
              <li>
                <ul
                  role="list"
                  class="-mx-2 space-y-1"
                >
                  <draggable
                    v-model="navigation"
                    item-key="instance_id"
                    animation="200"
                    ghost-class="opacity-40"
                    handle=".drag-handle"
                    @end="saveNavigationOrder"
                  >
                    <template #item="{ element: item }">
                      <li class="group relative min-w-0">
                        <div class="flex min-w-0 items-center">
                          <!-- MAIN LINK -->
        
                          <router-link
                            :to="item.to"
                            class="group flex min-w-0 flex-1 gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors duration-150"
                            :class="[
                              item.current ? 'text-white' : ''
                            ]"
                            :style="getNavItemStyle(item)"
                            @mouseover="hoveringItem = item.slug"
                            @mouseleave="hoveringItem = null"
                          >
                            <component
                              :is="resolveIcon(item.icon)"
                              class="h-6 w-6 shrink-0 transition-colors duration-150"
                              :style="{
                                color: hoveringItem === item.slug
                                  ? textIconHoverColor
                                  : textIconColor
                              }"
                            />


                            <span
                              v-if="editingSlug !== item.slug"
                              class="min-w-0 flex-1 truncate"
                            >
                              {{ item.custom_name || item.name }}
                            </span>

                            <span
                              v-else
                              class="min-w-0 flex-1"
                              @click.stop
                              @mousedown.stop
                            >
                              <input
                                v-model="editNameField"
                                class="w-full min-w-0 rounded bg-gray-700 px-2 py-1 text-sm text-white outline-none ring-1 ring-white/20 focus:ring-2 focus:ring-blue-400"
                                :maxlength="FEATURE_NAME_MAX_LENGTH"
                                :aria-label="`Rename ${item.custom_name || item.name}`"
                                autofocus
                                @click.stop
                                @mousedown.stop
                                @keyup.enter="$event.currentTarget.blur()"
                                @keyup.esc="cancelNameEdit"
                                @blur="saveName(item)"
                              >
                            </span>
                          </router-link>

                          <div
                            v-if="editingSlug !== item.slug"
                            class="ml-2 flex shrink-0 items-center gap-2 opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
                          >
                            <button
                              type="button"
                              class="rounded text-gray-400 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400"
                              :aria-label="`Rename ${item.custom_name || item.name}`"
                              @click.stop="startEditing(item)"
                            >
                              <PencilSquareIcon class="h-5 w-5" />
                            </button>
                            <button
                              type="button"
                              class="drag-handle h-5 w-5 text-gray-500 hover:text-gray-300 cursor-grab active:cursor-grabbing"
                              title="Drag to reorder"
                              aria-label="Drag to reorder"
                              @click.stop
                            >
                              <Bars3Icon class="h-5 w-5" />
                            </button>
                          </div>
                        </div>
                        <p
                          v-if="editingSlug === item.slug && renameError"
                          class="px-2 pt-1 text-xs font-medium text-red-300"
                          role="alert"
                        >
                          {{ renameError }}
                        </p>
                      </li>
                    </template>
                  </draggable>
                </ul>
              </li>
            </ul>
          </nav>

          <!-- NEW FEATURE TOOLTIP (unchanged)
  <transition
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-x-4"
    enter-to-class="opacity-100 translate-x-0"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="opacity-100 translate-x-0"
    leave-to-class="opacity-0 translate-x-4"
  >
    <div
  v-if="newFeatureSlug"
  class="absolute top-[55%] left-[175px] ml-3 -translate-y-1/2 w-36 h-48
         bg-[#2d8bff]/80 text-gray-900 text-xs rounded-lg shadow-lg p-3 z-50"
>
  🎉 <p class="text-lg text-zinc-100 font-semibold leading-5">
    New Product feature added!
  </p>
  <p class="text-base font-medium text-zinc-300 leading-5">
    Ready to customize — click to open.
  </p>
</div>

  </transition> -->
        </div>
      </div>

   


      <div
        class="overflow-y-scroll app-scroll h-screen transition-[padding] duration-300 ease-in-out"
        :class="desktopSidebarCollapsed ? 'lg:pl-0' : 'lg:pl-72'"
      >
        <div
          class="sticky top-0 z-[45] flex shrink-0 items-center gap-x-4 transition-all duration-300 ease-in-out sm:gap-x-6"
          :class="isFlixFeatureContext
            ? 'h-0 overflow-hidden border-b-0 bg-transparent px-0 shadow-none opacity-0 pointer-events-none'
            : 'h-14 border-b border-gray-200 bg-white px-4 shadow-sm opacity-100 sm:px-6 lg:px-8'"
        >
          <button
            type="button"
            class="-m-2.5 p-2.5 text-gray-700 lg:hidden"
            @click="sidebarOpen = true"
          >
            <span class="sr-only">Open sidebar</span>
            <Bars3Icon
              class="h-6 w-6"
              aria-hidden="true"
            />
          </button>

          <!-- Separator -->
          <div
            class="h-6 w-px bg-gray-900/10 lg:hidden"
            aria-hidden="true"
          />

          <div class="flex flex-1 items-center justify-end gap-x-4 lg:gap-x-5">
            <div class="flex items-center gap-x-4 lg:gap-x-5">
              <div class="relative group inline-flex items-center">
                <button
                  type="button"
                  class="relative -m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
                  @click="toggleCart"
                >
                  <ShoppingCartIcon
                    class="h-8 w-8"
                    aria-hidden="true"
                  />
                </button>
                <p
                  class="pointer-events-none absolute left-1/2 top-11 z-40 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover:opacity-100 group-hover:translate-y-0"
                >
                  Shopping
                </p>
              </div>

              <div class="relative group inline-flex items-center">
                <button
                  type="button"
                  class="relative -m-2.5 p-2.5 text-gray-400 hover:text-gray-500"
                >
                  <BellIcon
                    class="h-8 w-8"
                    aria-hidden="true"
                  />
                </button>
                <p
                  class="pointer-events-none absolute left-1/2 top-11 z-40 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover:opacity-100 group-hover:translate-y-0"
                >
                  Notifications
                </p>
              </div>

              <Menu
                v-slot="{ open }"
                as="div"
                class="relative z-50"
              >
                <div class="relative group/account inline-flex items-center">
                  <MenuButton class="-m-1.5 flex items-center p-1.5">
                    <span class="sr-only">Open user menu</span>
                    <div class="relative h-10 w-10 rounded-full bg-zinc-100">
                      <img
                        class="h-10 w-10 rounded-full bg-gray-50 object-cover mt-[2px]"
                        src="@/assets/media/images/default-avatar.png"
                        alt=""
                      >
                      <div
                        class="absolute -bottom-[10px] -right-[7px] flex h-5 w-5 items-center justify-center rounded-full border-[3px] border-white bg-zinc-300"
                      >
                        <ChevronDownIcon class="h-4 w-4 text-zinc-900" />
                      </div>
                    </div>
                  </MenuButton>
                  <p
                    v-if="!open"
                    class="pointer-events-none absolute left-1/2 top-12 z-50 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover/account:opacity-100 group-hover/account:translate-y-0"
                  >
                    Account
                  </p>
                </div>
                <transition
                  enter-active-class="transition ease-out duration-100"
                  enter-from-class="transform opacity-0 scale-95"
                  enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75"
                  leave-from-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95"
                >
                  <MenuItems class="absolute right-0 z-20 mt-3.5 w-56 origin-top-right rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/10">
                    <div class="mb-2 flex items-center gap-3 rounded-lg px-2 py-2">
                      <div class="h-10 w-10 overflow-hidden rounded-full bg-zinc-100">
                        <img
                          class="h-10 w-10 rounded-full bg-gray-50 object-cover"
                          src="@/assets/media/images/default-avatar.png"
                          alt=""
                        >
                      </div>
                      <div class="min-w-0">
                        <p class="truncate text-base font-semibold text-zinc-900">
                          Member
                        </p>
                      </div>
                    </div>
                    <div class="mb-2 h-px bg-zinc-200" />

                    <MenuItem
                      v-for="item in userNavigation"
                      :key="item.name"
                      v-slot="{ active }"
                    >
                      <router-link
                        :to="item.to"
                        :class="[
                          active ? 'bg-gray-50' : '',
                          'flex items-center gap-2 rounded-md px-3 py-2 text-base leading-6 text-gray-900 hover:bg-gray-50 font-medium'
                        ]"
                      >
                        {{ item.name }}
                      </router-link>
                    </MenuItem>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
          </div>
        </div>

        <transition
          enter-active-class="transition-all duration-300 ease-out"
          enter-from-class="opacity-0 -translate-y-2"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class="transition-all duration-200 ease-in"
          leave-from-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 -translate-y-2"
        >
          <div
            v-if="isFlixFeatureContext && !isFlixStudioRoute"
            class="hidden lg:flex fixed right-8 top-[14px] z-[180] items-center gap-x-4"
          >
            <div class="relative group inline-flex items-center">
              <button
                type="button"
                class="relative -m-2.5 p-2.5 text-white/85 hover:text-white"
                @click="toggleCart"
              >
                <ShoppingCartIcon
                  class="h-8 w-8"
                  aria-hidden="true"
                />
              </button>
              <p
                class="pointer-events-none absolute left-1/2 top-11 z-40 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover:opacity-100 group-hover:translate-y-0"
              >
                Shopping
              </p>
            </div>

            <div class="relative group inline-flex items-center">
              <button
                type="button"
                class="relative -m-2.5 p-2.5 text-white/85 hover:text-white"
              >
                <BellIcon
                  class="h-8 w-8"
                  aria-hidden="true"
                />
              </button>
              <p
                class="pointer-events-none absolute left-1/2 top-11 z-40 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover:opacity-100 group-hover:translate-y-0"
              >
                Notifications
              </p>
            </div>

            <Menu
              v-slot="{ open }"
              as="div"
              class="relative z-50"
            >
              <div class="relative group/account inline-flex items-center">
                <MenuButton class="-m-1.5 flex items-center p-1.5">
                  <span class="sr-only">Open user menu</span>
                  <div class="relative h-10 w-10 rounded-full">
                    <img
                      class="h-10 w-10 rounded-full bg-gray-50 object-cover mt-[2px]"
                      src="@/assets/media/images/default-avatar.png"
                      alt=""
                    >
                    <div
                      class="absolute -bottom-[10px] -right-[7px] flex h-5 w-5 items-center justify-center rounded-full bg-zinc-300"
                    >
                      <ChevronDownIcon class="h-4 w-4 text-zinc-900" />
                    </div>
                  </div>
                </MenuButton>
                <p
                  v-if="!open"
                  class="pointer-events-none absolute left-1/2 top-12 z-50 -translate-x-1/2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover/account:opacity-100 group-hover/account:translate-y-0"
                >
                  Account
                </p>
              </div>
              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <MenuItems class="absolute right-0 z-20 mt-3.5 w-56 origin-top-right rounded-xl bg-white p-2 shadow-lg ring-1 ring-gray-900/10">
                  <div class="mb-2 flex items-center gap-3 rounded-lg px-2 py-2">
                    <div class="h-10 w-10 overflow-hidden rounded-full bg-zinc-100">
                      <img
                        class="h-10 w-10 rounded-full bg-gray-50 object-cover"
                        src="@/assets/media/images/default-avatar.png"
                        alt=""
                      >
                    </div>
                    <div class="min-w-0">
                      <p class="truncate text-base font-semibold text-zinc-900">
                        Member
                      </p>
                    </div>
                  </div>
                  <div class="mb-2 h-px bg-zinc-200" />

                  <MenuItem
                    v-for="item in userNavigation"
                    :key="`flix-overlay-${item.name}`"
                    v-slot="{ active }"
                  >
                    <router-link
                      :to="item.to"
                      :class="[
                        active ? 'bg-gray-50' : '',
                        'flex items-center gap-2 rounded-md px-3 py-2 text-base leading-6 text-gray-900 hover:bg-gray-50 font-medium'
                      ]"
                    >
                      {{ item.name }}
                    </router-link>
                  </MenuItem>
                </MenuItems>
              </transition>
            </Menu>
          </div>
        </transition>



        <div
          v-if="showProductSettingsButton"
          class="hidden lg:flex fixed top-[72px] z-[46] group/product-settings transition-all duration-300 ease-in-out"
          :class="desktopSidebarCollapsed ? 'left-8' : 'left-[304px]'"
        >
          <button
            type="button"
            class="rounded-full bg-[#2d8bff] hover:bg-[#2d8bffd1] text-white p-2.5 ring-2 ring-white/90 shadow-lg transition-colors"
            @click="openCurrentFeatureSettings"
          >
            <Cog6ToothIcon class="h-6 w-6" />
          </button>
          <div
            class="pointer-events-none absolute bottom-full left-2 mb-2 rounded-xl bg-black/70 px-2 py-1.5 text-[11px] text-white whitespace-nowrap shadow-lg opacity-0 translate-y-1 transition-all duration-150 group-hover/product-settings:opacity-100 group-hover/product-settings:translate-y-0"
          >
            Product Settings
          </div>
        </div>

        <main class="">
          <div class="">
            <!-- Your content -->
            <SitePageEditorLayout
              v-if="isInlineFeaturePaywallEditorOpen"
              :key="`inline-feature-paywall-${inlineFeaturePaywallEditor?.pageId || 0}`"
              :page-id="inlineFeaturePaywallEditor?.pageId || ''"
              embedded
              embedded-back-label="Back to Feature"
              @exit-embedded="closeInlineFeaturePaywallEditor"
            />
            <router-view 
              v-else
              @open-delete="openDeleteModal"
              @toggle-settings="toggleSettingsDrawer"
            />
          </div>
        </main>
      </div>
    </div>

    <!-- Taskbar at the bottom of the screen with shadow on top -->
    <transition name="slide-up">
      <div
        v-if="showTaskbar"
        class="fixed bottom-0 left-0 right-0 z-50 border-t border-white/80 bg-white/85 px-4 py-3 shadow-[0_-16px_50px_rgba(15,23,42,.12)] backdrop-blur-xl transition-all duration-300 ease-in-out sm:px-6"
        @mouseenter="holdTaskbarOpen"
        @mouseleave="releaseTaskbar"
      >
        <div class="mx-auto flex max-w-[1700px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex items-center gap-3">
            <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-[#2D8CFF]"><SwatchIcon class="h-5 w-5" /></span>
            <div>
              <p class="text-[10px] font-extrabold uppercase tracking-[0.14em] text-slate-400">Current member theme</p>
              <p class="mt-0.5 text-sm font-bold text-slate-900">{{ activeMemberThemeName }} <span class="font-semibold text-slate-400">· v{{ activeMemberThemeVersion }}</span></p>
              <p
                v-if="themeActionFeedback"
                class="mt-1 flex items-center gap-1.5 text-xs font-semibold"
                :class="themeActionFeedback.type === 'error' ? 'text-red-600' : 'text-emerald-600'"
                role="status"
                aria-live="polite"
              >
                <CheckCircleIcon v-if="themeActionFeedback.type !== 'error'" class="h-4 w-4" />
                <ExclamationCircleIcon v-else class="h-4 w-4" />
                {{ themeActionFeedback.message }}
              </p>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end gap-2">
            <router-link to="/creator/themes" class="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition hover:border-blue-200 hover:bg-blue-50 hover:text-[#176fe2]">
              <SwatchIcon class="h-4 w-4" /> Switch theme
            </router-link>
            <router-link to="/creator/dashboard" class="rounded-xl bg-[#2D8CFF] px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-blue-500/15 transition hover:bg-[#176fe2]">
              Back to Creator Dashboard
            </router-link>
            <button
              type="button"
              class="rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60"
              :disabled="themeSettingsBusy"
              @click="saveThemeFromTaskbar"
            >
              {{ themeActionBusy === 'save' ? 'Saving…' : 'Save' }}
            </button>
            <button
              type="button"
              class="rounded-xl bg-emerald-500 px-4 py-2.5 text-sm font-bold text-white shadow-lg shadow-emerald-500/15 transition hover:bg-emerald-600 disabled:cursor-not-allowed disabled:opacity-60"
              :disabled="themeSettingsBusy"
              @click="publishThemeFromTaskbar"
            >
              {{ themeActionBusy === 'publish' ? 'Publishing…' : 'Publish' }}
            </button>
          </div>
        </div>
      </div>
    </transition>


    <!-- Modal -->
    <transition name="fade">
      <div
        v-if="isModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      >
        <div class="relative bg-white w-11/12 md:w-1/2 lg:w-3/4 rounded-lg p-6 shadow-lg">
          <button
            class="absolute top-2 right-2 z-[70] text-gray-600 hover:text-gray-800 hover:bg-zinc-200 px-2 rounded-full h-12 w-12 text-center"
            @click="closeModal"
          >
            <XMarkIcon class="h-7 w-7 mx-auto" />
          </button>

          <!-- Load the ThemeEditorFeatureSelectorModal component in the modal -->
          <ThemeEditorFeatureSelectorModal 
            @close="closeModal"
            @new-feature="showNewFeatureGuide"
          />
        </div>
      </div>
    </transition>

    <!-- DELETE CONFIRM MODAL -->
    <transition name="fade">
      <div
        v-if="isDeleteModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
      >
        <div class="relative bg-white w-96 rounded-lg p-6 shadow-lg text-center">
          <h2 class="text-lg font-semibold mb-4">
            Delete Feature?
          </h2>
          <p class="text-gray-600 mb-6">
            This will permanently remove <strong>{{ featureToDelete?.feature_name }}</strong>
            from your member platform.
          </p>

          <div class="flex justify-center space-x-4">
            <button
              class="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
              @click="confirmDeleteFeature"
            >
              Delete
            </button>

            <button
              class="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400"
              @click="closeDeleteModal"
            >
              Cancel
            </button>
          </div>

          <button
            class="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
            @click="closeDeleteModal"
          >
            <XMarkIcon class="h-5 w-5" />
          </button>
        </div>
      </div>
    </transition>


    <!-- SETTINGS DRAWER -->
    <Teleport to="body">
      <div
        v-if="settingsDrawerOpen"
        class="fixed inset-0 z-20 bg-transparent"
        @click="closeSettingsDrawer"
      />
      <transition
        enter-active-class="transition-transform duration-200 ease-out"
        enter-from-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-active-class="transition-transform duration-150 ease-in"
        leave-from-class="translate-x-0"
        leave-to-class="translate-x-full"
      >
        <aside
          v-if="settingsDrawerOpen"
          class="fixed inset-y-0 right-0 z-30 w-[360px] max-w-[86vw] bg-white/50 backdrop-blur-sm border-l border-zinc-200"
          @click.stop
        >
          <!-- Header -->
          <div class="h-16 px-4 border-b flex items-center justify-between">
            <div class="font-semibold">
              <!-- Title switches depending on context -->
              {{ selectedFeatureForSettings?.type === 'sidebar-settings'
                ? 'Global App Colors'
                : selectedFeatureForSettings?.type === 'global-app-settings'
                  ? 'Global App Settings'
                  : 'Main Product Feature Settings'
              }}
            </div>
            <button
              class="px-2 py-1 rounded bg-zinc-100 hover:bg-zinc-200"
              @click="closeSettingsDrawer"
            >
              Close
            </button>
          </div>

          <!-- SETTINGS CONTENT -->
          <div class="p-4 space-y-8 overflow-auto h-[calc(100%-4rem)]">
            <div
              v-if="selectedFeatureForSettings?.type === 'sidebar-settings'"
              class="space-y-6"
            >
              <!-- Navigation Section Title -->
              <h2 class="text-lg font-semibold text-zinc-800">
                Navigation Appearance
              </h2>

              <!-- Navigation Background Color -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium text-zinc-700">
                  Navigation Background Color
                </label>

                <!-- OPEN BUTTONS (circle + color wheel) -->
                <div class="flex items-center gap-3">
                  <!-- Current saved color -->
                  <div
                    class="w-8 h-8 rounded-full border border-zinc-300 shadow cursor-pointer"
                    :style="{ backgroundColor: sidebarBgColor }"
                    @click="showColorPicker = true"
                  />

                  <!-- Color wheel button -->
                  <button
                    class="w-8 h-8 rounded-full shadow flex items-center justify-center
                      bg-white hover:bg-zinc-100 cursor-pointer"
                    @click="showColorPicker = true"
                  >
                    <img
                      src="@/assets/media/images/platforma-color-selector.png"
                      class="w-8 h-8"
                    >
                  </button>
                </div>

                <!-- THE COLOR PICKER -->
                <transition
                  enter-active-class="transition duration-200 ease-out"
                  enter-from-class="opacity-0 translate-y-2"
                  enter-to-class="opacity-100 translate-y-0"
                  leave-active-class="transition duration-150 ease-in"
                  leave-from-class="opacity-100 translate-y-0"
                  leave-to-class="opacity-0 translate-y-2"
                >
                  <div
                    v-if="showColorPicker"
                    class="relative mt-3"
                  >
                    <ModernColorPicker
                      ref="pickerRef"
                      v-model="sidebarBgColor"
                      class="z-50 relative"
                    />
                  </div>
                </transition>
              </div>



              <!-- Text & Icon Color -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium text-zinc-700">
                  Navigation Text & Icon Color
                </label>

                <div class="flex items-center gap-3">
                  <!-- Current color -->
                  <div
                    class="w-8 h-8 rounded-full border border-zinc-300 shadow cursor-pointer"
                    :style="{ backgroundColor: textIconColor }"
                    @click="showTextIconPicker = true"
                  />

                  <!-- Color Wheel Button -->
                  <button
                    class="w-8 h-8 rounded-full shadow bg-white hover:bg-zinc-100 flex items-center justify-center"
                    @click="showTextIconPicker = true"
                  >
                    <img
                      src="@/assets/media/images/platforma-color-selector.png"
                      class="w-8 h-8"
                    >
                  </button>
                </div>

                <transition
                  enter-active-class="transition duration-200 ease-out"
                  enter-from-class="opacity-0 translate-y-2"
                  enter-to-class="opacity-100 translate-y-0"
                  leave-active-class="transition duration-150 ease-in"
                  leave-from-class="opacity-100 translate-y-0"
                  leave-to-class="opacity-0 translate-y-2"
                >
                  <div
                    v-if="showTextIconPicker"
                    class="relative mt-3"
                  >
                    <ModernColorPicker
                      ref="textIconPickerRef"
                      v-model="textIconColor"
                      class="z-50"
                    />
                  </div>
                </transition>
              </div>

              <!-- Text & Icon Hover Color -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium text-zinc-700">
                  Navigation Text & Icon HOVER Color
                </label>

                <div class="flex items-center gap-3">
                  <!-- Current color -->
                  <div
                    class="w-8 h-8 rounded-full border border-zinc-300 shadow cursor-pointer"
                    :style="{ backgroundColor: textIconHoverColor }"
                    @click="showTextIconHoverPicker = true"
                  />

                  <!-- Color Wheel Button -->
                  <button
                    class="w-8 h-8 rounded-full shadow bg-white hover:bg-zinc-100 flex items-center justify-center"
                    @click="showTextIconHoverPicker = true"
                  >
                    <img
                      src="@/assets/media/images/platforma-color-selector.png"
                      class="w-8 h-8"
                    >
                  </button>
                </div>

                <transition
                  enter-active-class="transition duration-200 ease-out"
                  enter-from-class="opacity-0 translate-y-2"
                  enter-to-class="opacity-100 translate-y-0"
                  leave-active-class="transition duration-150 ease-in"
                  leave-from-class="opacity-100 translate-y-0"
                  leave-to-class="opacity-0 translate-y-2"
                >
                  <div
                    v-if="showTextIconHoverPicker"
                    class="relative mt-3"
                  >
                    <ModernColorPicker
                      ref="textIconHoverPickerRef"
                      v-model="textIconHoverColor"
                      class="z-50"
                    />
                  </div>
                </transition>
              </div>

              <!-- Product Hover Color -->
              <div class="flex flex-col gap-2">
                <label class="text-sm font-medium text-zinc-700">
                  Navigation Background HOVER Color
                </label>

                <div class="flex items-center gap-3">
                  <!-- Current color -->
                  <div
                    class="w-8 h-8 rounded-full border border-zinc-300 shadow cursor-pointer"
                    :style="{ backgroundColor: productHoverColor }"
                    @click="showProductHoverPicker = true"
                  />

                  <!-- Color Wheel Button -->
                  <button
                    class="w-8 h-8 rounded-full shadow bg-white hover:bg-zinc-100 flex items-center justify-center"
                    @click="showProductHoverPicker = true"
                  >
                    <img
                      src="@/assets/media/images/platforma-color-selector.png"
                      class="w-8 h-8"
                    >
                  </button>
                </div>

                <transition
                  enter-active-class="transition duration-200 ease-out"
                  enter-from-class="opacity-0 translate-y-2"
                  enter-to-class="opacity-100 translate-y-0"
                  leave-active-class="transition duration-150 ease-in"
                  leave-from-class="opacity-100 translate-y-0"
                  leave-to-class="opacity-0 translate-y-2"
                >
                  <div
                    v-if="showProductHoverPicker"
                    class="relative mt-3"
                  >
                    <ModernColorPicker
                      ref="productHoverPickerRef"
                      v-model="productHoverColor"
                      class="z-50"
                    />
                  </div>
                </transition>
              </div>


              <!-- Future sidebar settings go here -->
              <!-- (More settings coming soon…) -->
              <div class="pt-4 text-xs text-zinc-500">
                (More sidebar settings coming soon…)
              </div>
            </div>

            <!-- ======================================= -->
            <!-- GLOBAL APP SETTINGS (favicon + SEO)     -->
            <!-- ======================================= -->
            <div
              v-else-if="selectedFeatureForSettings?.type === 'global-app-settings'"
              class="space-y-8"
            >
              <!-- Favicon Section -->
              <div class="space-y-2">
                <h2 class="text-lg font-semibold text-zinc-800">
                  App Favicon
                </h2>
                <img
                  :src="faviconExample"
                  alt="Current Favicon"
                  class="w-full "
                >
                <p class="text-sm text-zinc-600">
                  Upload a custom favicon for the member platform.
                </p>

                <div class="flex items-center gap-4 mt-2">
                  <img
                    :src="faviconPreview"
                    alt="Current Favicon"
                    class="w-10 h-10 rounded border border-zinc-300 shadow"
                  >

                  <button
                    class="px-3 py-2 rounded bg-zinc-100 hover:bg-zinc-200 text-sm"
                    :disabled="uploadingFavicon"
                    @click="triggerFaviconUpload"
                  >
                    {{ uploadingFavicon ? 'Uploading…' : 'Upload Favicon' }}
                  </button>

                  <input
                    ref="faviconInput"
                    class="hidden"
                    type="file"
                    accept="image/*"
                    @change="updateFavicon"
                  >
                </div>
              </div>

              <!-- Membership Name Section -->
              <div class="space-y-2 pt-4 border-t border-zinc-200">
                <h2 class="text-lg font-semibold text-zinc-800">
                  Membership Name
                </h2>
                <input
                  v-model="membershipName"
                  type="text"
                  class="w-full border rounded px-3 py-2 text-sm"
                  maxlength="150"
                  placeholder="Enter membership name"
                >
              </div>

              <!-- SEO Section -->
              <div class="space-y-2 pt-4 border-t border-zinc-200">
                <h2 class="text-lg font-semibold text-zinc-800">
                  SEO Settings
                </h2>

                <label class="text-sm font-medium text-zinc-700">SEO Title</label>
                <input
                  v-model="seoTitle"
                  type="text"
                  class="w-full border rounded px-3 py-2 text-sm"
                  placeholder="Enter title for member area"
                >

                <label class="text-sm font-medium text-zinc-700 mt-3">SEO Description</label>
                <textarea
                  v-model="seoDescription"
                  rows="3"
                  class="w-full border rounded px-3 py-2 text-sm"
                  placeholder="Short description for search engines"
                />
              </div>

              <!-- Save Button -->
              <div class="pt-4">
                <button
                  class="px-4 py-2 bg-[#2d8bff] text-white rounded-lg hover:bg-[#2d8bffd1] disabled:cursor-not-allowed disabled:opacity-60"
                  :disabled="globalSettingsSaving"
                  @click="saveGlobalAppSettings"
                >
                  {{ globalSettingsSaving ? 'Saving…' : 'Save Settings' }}
                </button>
                <p
                  v-if="globalSettingsFeedback"
                  class="mt-3 rounded-lg border px-3 py-2 text-sm"
                  :class="globalSettingsFeedback.type === 'success'
                    ? 'border-emerald-200 bg-emerald-50 text-emerald-800'
                    : 'border-red-200 bg-red-50 text-red-700'"
                  :role="globalSettingsFeedback.type === 'error' ? 'alert' : 'status'"
                >
                  {{ globalSettingsFeedback.message }}
                </p>
              </div>
            </div>

            <!-- ======================================= -->
            <!-- FEATURE SETTINGS                        -->
            <!-- ======================================= -->
            <div v-else>
              <!-- Feature Name -->
              <div class="text-sm text-zinc-600">
                Feature:
                <span class="font-semibold">
                  {{ selectedFeatureForSettings?.custom_name || selectedFeatureForSettings?.feature_name }}
                </span>
              </div>

              <!-- ========================= -->
              <!-- PUBLISH SECTION           -->
              <!-- ========================= -->
              <div class="space-y-3">
                <h3 class="text-sm font-semibold text-zinc-700">
                  Product Published
                </h3>

                <div class="flex items-center justify-between gap-4">
                  <span class="text-sm text-zinc-600">
                    Make this feature visible to members
                  </span>

                  <!-- TOGGLE -->
                  <button
                    type="button"
                    class="relative inline-flex h-6 w-11 shrink-0 items-center cursor-pointer"
                    :aria-pressed="selectedFeatureForSettings?.is_published === 1 ? 'true' : 'false'"
                    aria-label="Publish setting"
                    @click="togglePublish(selectedFeatureForSettings)"
                  >
                    <!-- Track -->
                    <div
                      class="absolute inset-0 rounded-full transition-colors duration-200"
                      :class="selectedFeatureForSettings?.is_published === 1 
                        ? 'bg-green-500' 
                        : 'bg-gray-300'"
                    />

                    <!-- Knob -->
                    <span
                      class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200"
                      :class="selectedFeatureForSettings?.is_published === 1 
                        ? 'translate-x-5' 
                        : 'translate-x-0'"
                    />
                  </button>
                </div>
              </div>

              <!-- ========================= -->
              <!-- FEATURE PRICING SECTION   -->
              <!-- ========================= -->
              <div class="space-y-3 pt-4 border-t border-zinc-200">
                <h3 class="text-sm font-semibold text-zinc-700">
                  Product Feature Pricing
                </h3>

                <div class="flex items-center justify-between">
                  <span class="text-sm text-zinc-600">
                    Require payment to unlock this feature
                  </span>

                  <button
                    type="button"
                    class="relative inline-flex h-6 w-11 items-center cursor-pointer"
                    :aria-pressed="selectedFeatureForSettings?.is_paywalled === 1 ? 'true' : 'false'"
                    aria-label="Feature pricing setting"
                    @click="toggleFeaturePricing(selectedFeatureForSettings)"
                  >
                    <div
                      class="absolute inset-0 rounded-full transition-colors duration-200"
                      :class="selectedFeatureForSettings?.is_paywalled === 1
                        ? 'bg-green-500'
                        : 'bg-gray-300'"
                    />
                    <span
                      class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200"
                      :class="selectedFeatureForSettings?.is_paywalled === 1
                        ? 'translate-x-5'
                        : 'translate-x-0'"
                    />
                  </button>
                </div>

                <div
                  v-if="selectedFeatureForSettings?.is_paywalled === 1"
                  class="space-y-3 rounded-xl border border-zinc-200 p-3"
                >
                  <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <label class="text-xs font-semibold uppercase tracking-wide text-zinc-500">
                      Billing cadence
                      <select
                        v-model="selectedFeatureForSettings.paywall_billing_cadence"
                        class="mt-1 w-full rounded-lg border border-zinc-300 px-2.5 py-2 text-sm text-zinc-700"
                      >
                        <option value="one_time">One time</option>
                        <option value="monthly">Monthly</option>
                        <option value="yearly">Yearly</option>
                      </select>
                    </label>

                    <label class="text-xs font-semibold uppercase tracking-wide text-zinc-500">
                      Price (USD)
                      <input
                        v-model.number="selectedFeatureForSettings.paywall_price_dollars"
                        type="number"
                        min="0.50"
                        step="0.01"
                        class="mt-1 w-full rounded-lg border border-zinc-300 px-2.5 py-2 text-sm text-zinc-700"
                        placeholder="29.00"
                      >
                    </label>
                  </div>

                  <label class="block text-xs font-semibold uppercase tracking-wide text-zinc-500">
                    Payment provider
                    <select
                      v-model="selectedFeatureForSettings.paywall_provider"
                      class="mt-1 w-full rounded-lg border border-zinc-300 px-2.5 py-2 text-sm text-zinc-700"
                    >
                      <option value="platforma_payments">Platforma Payments</option>
                      <option value="creator_stripe">Creator Stripe Account</option>
                    </select>
                  </label>

                  <div class="flex flex-wrap items-center gap-2 pt-1">
                    <button
                      type="button"
                      class="rounded-lg bg-[#2d8bff] px-3 py-2 text-xs font-semibold text-white hover:bg-[#2d8bffd1] disabled:cursor-not-allowed disabled:opacity-60"
                      :disabled="featurePricingSaveBusy"
                      @click="saveFeaturePricing(selectedFeatureForSettings)"
                    >
                      {{ featurePricingSaveBusy ? 'Saving...' : 'Save Pricing' }}
                    </button>
                    <button
                      v-if="selectedFeatureForSettings?.paywall_page_id"
                      type="button"
                      class="rounded-lg border border-zinc-300 px-3 py-2 text-xs font-semibold text-zinc-700 hover:bg-zinc-50"
                      @click="openFeaturePaywallPageEditor(selectedFeatureForSettings)"
                    >
                      Edit Lock Page
                    </button>
                  </div>

                  <p
                    v-if="featurePricingSaveMessage"
                    class="text-xs"
                    :class="featurePricingSaveError ? 'text-red-600' : 'text-emerald-600'"
                  >
                    {{ featurePricingSaveMessage }}
                  </p>
                </div>
              </div>
              <!-- ========================= -->
              <!-- STOREFRONT THEME SECTION  -->
              <!-- ========================= -->
              <div
                v-if="isSelectedStorefrontFeature"
                class="space-y-3 pt-4 border-t border-zinc-200"
              >
                <h3 class="text-sm font-semibold text-zinc-700">
                  Storefront Design
                </h3>
                <p class="text-xs leading-5 text-zinc-500">
                  Preview and switch the theme used by this Storefront. Products, collections, orders, and uploaded branding remain in place.
                </p>
                <button
                  type="button"
                  class="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2.5 text-sm font-bold text-[#176fe2] transition hover:border-blue-300 hover:bg-blue-100"
                  @click="openStorefrontThemePicker"
                >
                  <SwatchIcon class="h-4 w-4" />
                  Browse Storefront Themes
                </button>
              </div>
              <!-- ========================= -->
              <!-- INCOGNITO SECTION         -->
              <!-- ========================= -->
              <div class="space-y-3 pt-2 border-t border-zinc-200">
                <h3 class="text-sm font-semibold text-zinc-700">
                  Incognito Feature Access
                </h3>

                <div class="flex items-center justify-between gap-4">
                  <span class="text-sm text-zinc-600">
                    Hide this feature by default and require explicit member access
                  </span>

                  <button
                    type="button"
                    class="relative inline-flex h-6 w-11 shrink-0 items-center cursor-pointer"
                    :aria-pressed="selectedFeatureForSettings?.is_hidden === 1 ? 'true' : 'false'"
                    aria-label="Incognito setting"
                    @click="toggleIncognito(selectedFeatureForSettings)"
                  >
                    <div
                      class="absolute inset-0 rounded-full transition-colors duration-200"
                      :class="selectedFeatureForSettings?.is_hidden === 1
                        ? 'bg-green-500'
                        : 'bg-gray-300'"
                    />
                    <span
                      class="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200"
                      :class="selectedFeatureForSettings?.is_hidden === 1
                        ? 'translate-x-5'
                        : 'translate-x-0'"
                    />
                  </button>
                </div>
                <p class="text-xs leading-5 text-zinc-500">
                  Incognito features can be unlocked for members manually or by lesson completion rules.
                </p>
              </div>

              <!-- ========================= -->
              <!-- DELETE SECTION            -->
              <!-- ========================= -->
              <div class="space-y-3 pt-2 border-t border-zinc-200">
                <h3 class="text-sm font-semibold text-zinc-700">
                  Danger Zone
                </h3>

                <button
                  class="w-full px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                  @click="openDeleteModal(selectedFeatureForSettings)"
                >
                  Delete Feature
                </button>
              </div>
            </div> <!-- END FEATURE SETTINGS -->
          </div>
        </aside>
      </transition>
    </Teleport>
  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted, watch } from 'vue';
import { useFeatureStore } from '@/stores/featureStore';
import { useAppSettingsStore } from '@/stores/appSettingsStore';
import { useRouter } from 'vue-router';
import draggable from "vuedraggable";

const router = useRouter();

import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import {
  Bars3Icon,
  BellIcon,
  Cog6ToothIcon,
  XMarkIcon,
  CameraIcon,
  PlusCircleIcon,
  HomeIcon,
  ChatBubbleBottomCenterTextIcon,
  AcademicCapIcon,
  VideoCameraIcon,
  BookOpenIcon,
  GlobeAltIcon,
  ShoppingCartIcon,
  NewspaperIcon,
  FilmIcon,
  QueueListIcon,
  PhoneArrowUpRightIcon,
  MicrophoneIcon,
  DocumentTextIcon,
  PencilSquareIcon,
  SwatchIcon,
  CheckCircleIcon,
  ExclamationCircleIcon
} from '@heroicons/vue/24/outline';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';

import ThemeEditorFeatureSelectorModal from '@/Components/ThemeEditorFeatureSelectorModal.vue';
import CartComponent from '@/Components/ShopifyStoreCart.vue';
import ModernColorPicker from '@/Components/ModernColorPicker.vue';
import SitePageEditorLayout from '@/layouts/SitePageEditorLayout.vue';
import memberUiPlaceholderAsset from '@/assets/media/images/member-ui-placeholder.png';

import { useRoute } from "vue-router";
const route = useRoute();

const navigation = ref([]);
const featureStore = useFeatureStore();
const appSettingsStore = useAppSettingsStore();
const activeFeatureForSettings = computed(() => {
  const slug = String(route.params.featureSlug || '').trim();
  if (!slug) return null;
  return featureStore.state.featureInstances.find(
    (feature) => String(feature?.slug || '').trim() === slug
  ) || null;
});

const isFlixFeatureContext = computed(() => {
  const feature = activeFeatureForSettings.value;
  if (!feature) return false;

  const probes = [
    feature?.feature_name,
    feature?.name,
    feature?.feature_type,
    feature?.featureType,
    feature?.template_name,
    feature?.templateName,
    route.params.featureSlug,
  ];

  return probes.some((value) => String(value || '').trim().toLowerCase().includes('flix'));
});

const isFlixStudioRoute = computed(() => {
  const routeName = String(route.name || '').trim();
  return routeName === 'CreatorEditorFlixTheatreContentManageProduct'
    || routeName === 'FlixTheatreStudioEditVideoPage';
});

const showProductSettingsButton = computed(() => {
  if (!activeFeatureForSettings.value) return false;
  if (!isFlixFeatureContext.value) return true;
  return isFlixStudioRoute.value;
});

const apiProxyUrl = process.env.VUE_APP_API_PROXY_URL;

const newFeatureSlug = ref(null);
const tooltipY = ref(200); // default

const sidebarEditingHover = ref(false);

// Sidebar background colors (later we save them)
const sidebarBgColor = ref('#1f2937'); // current gray-900
// New Global App Customization colors
// New Global App Customization colors
const textIconColor = ref('#a1a1aa');        // zinc-400
const textIconHoverColor = ref('#f4f4f5');   // zinc-100
const productHoverColor = ref('#27272a');    // zinc-800

// Flags to prevent preview being overwritten while uploading
// const uploadingLogo = ref(false);
const uploadingFavicon = ref(false);
const globalSettingsSaving = ref(false);
const globalSettingsFeedback = ref(null);
const themeActionBusy = ref('');
const themeActionFeedback = ref(null);
const themeSettingsBusy = computed(() => Boolean(globalSettingsSaving.value || themeActionBusy.value));
let themeActionFeedbackTimer = null;


const openSidebarSettings = () => {
  selectedFeatureForSettings.value = { type: "sidebar-settings" };
  settingsDrawerOpen.value = true;
};

const openGlobalAppSettings = () => {
  selectedFeatureForSettings.value = { type: "global-app-settings" };
  globalSettingsFeedback.value = null;
  settingsDrawerOpen.value = true;
};

const showColorPicker = ref(false);
const showTextIconPicker = ref(false);
const showTextIconHoverPicker = ref(false);
const showProductHoverPicker = ref(false);

// const closeColorPicker = () => {
//   showColorPicker.value = false;
//   saveSidebarColor(); // OPTIONAL — auto-save on close
// };

const pickerRef = ref(null);
const textIconPickerRef = ref(null);
const textIconHoverPickerRef = ref(null);
const productHoverPickerRef = ref(null);
const hoveringItem = ref(null);


// Close when clicking outside
function handleClickOutside(e) {
  const pickers = [
    { el: pickerRef.value, toggle: showColorPicker },
    { el: textIconPickerRef.value, toggle: showTextIconPicker },
    { el: textIconHoverPickerRef.value, toggle: showTextIconHoverPicker },
    { el: productHoverPickerRef.value, toggle: showProductHoverPicker },
  ];

  pickers.forEach(({ el, toggle }) => {
    if (!toggle.value) return;
    if (!el) return;

    // If it's a Vue component, use $el
    const dom = el.$el ?? el;

    if (!dom.contains(e.target)) {
      toggle.value = false;
    }
  });
}

const getNavItemStyle = (item) => {
  const isHover = hoveringItem.value === item.slug;

  return {
    color: isHover ? textIconHoverColor.value : textIconColor.value,
    backgroundColor: isHover ? productHoverColor.value : 'transparent'
  };
};



// async function saveSidebarColor() {
//   console.log("Saving color:", sidebarBgColor.value);
//   // later: API call
// }


const showNewFeatureGuide = (slug) => {
  newFeatureSlug.value = slug;

  // Compute simple Y position based on index
  const index = navigation.value.findIndex(f => f.slug === slug);
  tooltipY.value = 150 + index * 48; // 48px per row approx

  setTimeout(() => {
    newFeatureSlug.value = null;
  }, 7000);
}

watch(
  () => featureStore.state.featureInstances,
  () => {
    fetchFeatures();
  },
  { deep: true }
);

const fetchFeatures = () => {
  // Always sort by navigation_order coming from DB
  const ordered = [...featureStore.state.featureInstances].sort(
    (a, b) => (a.navigation_order ?? 9999) - (b.navigation_order ?? 9999)
  );

  const dashboard = navigation.value.find(n => n.instance_id === -1) || {
    name: "Dashboard",
    to: "/creator/theme-editor",
    icon: "HomeIcon",
    instance_id: -1,
  };

  const features = ordered.map((feature) => ({
    name: feature.feature_name,
    custom_name: feature.custom_name,
    to: `/creator/theme-editor/${feature.slug}`,
    slug: feature.slug,
    icon: feature.icon,
    instance_id: feature.instance_id,
  }));

  navigation.value = [dashboard, ...features];
};


const resolveIcon = (iconName) => {
  const icons = {
    HomeIcon,
    ChatBubbleBottomCenterTextIcon,
    AcademicCapIcon,
    VideoCameraIcon,
    BookOpenIcon,
    GlobeAltIcon,
    ShoppingCartIcon,
    NewspaperIcon,
    FilmIcon,
    QueueListIcon,
    PhoneArrowUpRightIcon,
    MicrophoneIcon,
    DocumentTextIcon,
    CalendarDaysIcon: PhoneArrowUpRightIcon,
  };

  return icons[iconName] || null;
};

const userNavigation = [
  { name: 'Your profile', to: '/creator/theme-editor/editor-member-settings' },
  { name: 'Sign out', href: '#' }
];

const sidebarOpen = ref(false);
const desktopSidebarCollapsed = ref(false);
const isCartOpen = ref(false);
const toggleCart = () => {
  isCartOpen.value = !isCartOpen.value;
};
let flixSidebarTimer = null;

const clearFlixSidebarTimer = () => {
  if (!flixSidebarTimer) return;
  clearTimeout(flixSidebarTimer);
  flixSidebarTimer = null;
};

const scheduleFlixSidebarCollapse = (delayMs = 220) => {
  clearFlixSidebarTimer();
  flixSidebarTimer = setTimeout(() => {
    desktopSidebarCollapsed.value = true;
    sidebarOpen.value = false;
  }, Math.max(0, Number(delayMs) || 0));
};

const openDesktopSidebar = ({ openMobile = false } = {}) => {
  clearFlixSidebarTimer();
  desktopSidebarCollapsed.value = false;
  if (
    openMobile
    && typeof window !== 'undefined'
    && window.innerWidth < 1024
  ) {
    sidebarOpen.value = true;
  }
};

const isFlixHomeImmersiveRoute = computed(() => {
  return isFlixFeatureContext.value && String(route.name || '').trim() === 'DynamicFeatureRenderer';
});
const isFlixImmersiveChrome = computed(() => {
  return isFlixHomeImmersiveRoute.value && desktopSidebarCollapsed.value;
});

const emitFlixLayoutState = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('platforma:flix-layout-state', {
    detail: {
      sidebarCollapsed: Boolean(desktopSidebarCollapsed.value),
      immersiveChrome: Boolean(isFlixImmersiveChrome.value),
    },
  }));
};

const handleFlixLayoutStateRequest = () => {
  emitFlixLayoutState();
};

const handleFlixSidebarRequest = (event) => {
  const action = String(event?.detail?.action || '').trim().toLowerCase();
  if (!action) return;

  if (action === 'open') {
    openDesktopSidebar({ openMobile: true });
    return;
  }
  if (action === 'close') {
    scheduleFlixSidebarCollapse(0);
  }
};

watch(
  () => isFlixHomeImmersiveRoute.value,
  (isImmersive) => {
    if (isImmersive) {
      scheduleFlixSidebarCollapse(220);
      return;
    }
    openDesktopSidebar({ openMobile: false });
  },
  { immediate: true }
);

watch(
  () => [desktopSidebarCollapsed.value, isFlixImmersiveChrome.value],
  () => {
    emitFlixLayoutState();
  },
  { immediate: true }
);
const showTaskbar = ref(false);
const taskbarHovered = ref(false);
const memberThemeCatalog = Object.freeze({ core: Object.freeze({ name: 'Core', version: '1.0.0' }) });
const activeMemberThemeKey = computed(() => (
  String(appSettingsStore.settings?.member_theme_key || 'core').trim().toLowerCase()
));
const activeMemberTheme = computed(() => {
  return memberThemeCatalog[activeMemberThemeKey.value] || memberThemeCatalog.core;
});
const activeMemberThemeName = computed(() => activeMemberTheme.value.name);
const activeMemberThemeVersion = computed(() => String(appSettingsStore.settings?.member_theme_version || activeMemberTheme.value.version));
const logoSrc = ref(null);
const memberLogoSrc = computed(() => {
  const locallySelectedLogo = String(logoSrc.value || '').trim();
  if (locallySelectedLogo) return locallySelectedLogo;

  const savedLogoEndpoint = String(appSettingsStore.logo || '').trim();
  if (savedLogoEndpoint) return savedLogoEndpoint;

  return memberUiPlaceholderAsset;
});

const handleMemberLogoError = (event) => {
  const image = event?.currentTarget;
  if (!image || image.dataset.fallbackApplied === 'true') return;
  image.dataset.fallbackApplied = 'true';
  logoSrc.value = memberUiPlaceholderAsset;
  image.src = memberUiPlaceholderAsset;
};

const fileInput = ref(null);
const triggerImageUpload = () => {
  fileInput.value.click();
};


const updateLogo = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // Show preview immediately in UI (correct)
  const reader = new FileReader();
  reader.onload = (e) => {
    logoSrc.value = e.target.result;
  };
  reader.readAsDataURL(file);

  // Upload to backend
  await appSettingsStore.uploadLogo(file);

  // 🔥 FORCE STORE TO RELOAD FROM BACKEND
  await appSettingsStore.fetchSettings();
  await appSettingsStore.fetchLogo();

  // 🔥 NOW USE THE STORE VALUE — NOT A HARD-CODED URL
  logoSrc.value = `${appSettingsStore.logo}?t=${Date.now()}`;

};




const isModalOpen = ref(false);
const openModal = () => {
  isModalOpen.value = true;
};
const closeModal = () => {
  isModalOpen.value = false;
};

const isDeleteModalOpen = ref(false);
const featureToDelete = ref(null);

const openDeleteModal = (feature) => {
  featureToDelete.value = feature;
  isDeleteModalOpen.value = true;
};

const closeDeleteModal = () => {
  isDeleteModalOpen.value = false;
  featureToDelete.value = null;
};

const confirmDeleteFeature = async () => {
  if (!featureToDelete.value) return;

  try {
    const response = await fetch(
      `${apiProxyUrl}/api/feature-instances/${featureToDelete.value.instance_id}`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      console.error('Delete failed:', response.statusText);
      return;
    }

    // Refresh sidebar
    await featureStore.fetchFeatureInstances();

    // Close modal
    closeDeleteModal();

    // 🔥 NEW — Close settings drawer too
    closeSettingsDrawer();

    // Redirect back to editor home
    router.push('/creator/theme-editor');

  } catch (err) {
    console.error('Error deleting feature:', err);
  }
};

const settingsDrawerOpen = ref(false);
const selectedFeatureForSettings = ref(null);
const featurePricingSaveBusy = ref(false);
const featurePricingSaveMessage = ref('');
const featurePricingSaveError = ref(false);
const inlineFeaturePaywallEditor = ref(null);

const isSelectedStorefrontFeature = computed(() => {
  const feature = selectedFeatureForSettings.value;
  if (!feature || feature?.type) return false;
  return [
    feature?.feature_name,
    feature?.name,
    feature?.feature_type,
    feature?.featureType,
    feature?.template_name,
    feature?.templateName,
  ].some((value) => String(value || '').trim().toLowerCase().includes('storefront'));
});

const isInlineFeaturePaywallEditorOpen = computed(() => {
  const pageId = Number.parseInt(String(inlineFeaturePaywallEditor.value?.pageId || 0), 10) || 0;
  return pageId > 0;
});

const closeInlineFeaturePaywallEditor = () => {
  inlineFeaturePaywallEditor.value = null;
};

const normalizeFeaturePaywallCadenceValue = (value) => {
  const token = String(value || '').trim().toLowerCase();
  if (token === 'monthly' || token === 'yearly') return token;
  return 'one_time';
};

const normalizeFeaturePaywallProviderValue = (value) => {
  const token = String(value || '').trim().toLowerCase();
  if (token === 'creator_stripe') return 'creator_stripe';
  return 'platforma_payments';
};

const toPaywallDollars = (cents) => {
  const amountCents = Number.parseInt(String(cents ?? 0), 10);
  const safeCents = Number.isFinite(amountCents) ? Math.max(0, amountCents) : 0;
  return Number((safeCents / 100).toFixed(2));
};

const toPaywallCents = (dollars) => {
  const parsed = Number(dollars);
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.round(parsed * 100));
};

const applyFeaturePricingDefaults = (feature) => {
  if (!feature || typeof feature !== 'object') return feature;
  const paywallPriceCents = Number.parseInt(String(feature?.paywall_price_cents ?? 0), 10);
  return {
    ...feature,
    is_paywalled: Number(feature?.is_paywalled) ? 1 : 0,
    paywall_billing_cadence: normalizeFeaturePaywallCadenceValue(feature?.paywall_billing_cadence),
    paywall_provider: normalizeFeaturePaywallProviderValue(feature?.paywall_provider),
    paywall_currency_code: 'USD',
    paywall_price_cents: Number.isFinite(paywallPriceCents) ? Math.max(0, paywallPriceCents) : 0,
    paywall_price_dollars: toPaywallDollars(feature?.paywall_price_cents),
    paywall_page_id: Number.parseInt(String(feature?.paywall_page_id || 0), 10) || null,
  };
};

const findFeatureByInstanceId = (instanceId) => {
  const safeId = Number.parseInt(String(instanceId || 0), 10) || 0;
  if (!safeId) return null;
  return featureStore.state.featureInstances.find(
    (entry) => Number.parseInt(String(entry?.instance_id || 0), 10) === safeId
  ) || null;
};

const openSettingsDrawer = (feature) => {
  selectedFeatureForSettings.value = applyFeaturePricingDefaults(feature);
  featurePricingSaveMessage.value = '';
  featurePricingSaveError.value = false;
  settingsDrawerOpen.value = true;
};
const openCurrentFeatureSettings = () => {
  if (!activeFeatureForSettings.value) return;
  toggleSettingsDrawer(activeFeatureForSettings.value);
};

const closeSettingsDrawer = () => {
  settingsDrawerOpen.value = false;
  selectedFeatureForSettings.value = null;
  featurePricingSaveMessage.value = '';
  featurePricingSaveError.value = false;
};

const openStorefrontThemePicker = async () => {
  const feature = selectedFeatureForSettings.value;
  const featureSlug = String(feature?.slug || route.params?.featureSlug || '').trim();
  const instanceId = Number(feature?.instance_id || feature?.instanceId || 0) || 0;
  if (!featureSlug) return;
  closeSettingsDrawer();
  await router.push({
    name: 'DynamicFeatureRenderer',
    params: { featureSlug },
    query: {
      ...(instanceId ? { instanceId: String(instanceId) } : {}),
      storefrontThemes: '1',
    },
  });
};

const toggleSettingsDrawer = (feature) => {
  if (settingsDrawerOpen.value) {
    closeSettingsDrawer();
  } else {
    openSettingsDrawer(feature);
  }
};


const FEATURE_NAME_MAX_LENGTH = 60;
const editingSlug = ref(null);
const editNameField = ref("");
const renameError = ref("");
const nameSaveInFlight = ref(false);

const startEditing = (item) => {
  editingSlug.value = item.slug;
  editNameField.value = item.custom_name || item.name;
  renameError.value = "";
};

const cancelNameEdit = () => {
  if (nameSaveInFlight.value) return;
  editingSlug.value = null;
  editNameField.value = "";
  renameError.value = "";
};

const normalizeFeatureName = (value) => Array.from(String(value || ""))
  .map((character) => {
    const code = character.charCodeAt(0);
    return code <= 31 || code === 127 ? " " : character;
  })
  .join("")
  .replace(/\s+/g, " ")
  .trim();

const saveName = async (item) => {
  if (nameSaveInFlight.value || editingSlug.value !== item.slug) return;
  const newName = normalizeFeatureName(editNameField.value);
  const existingName = normalizeFeatureName(item.custom_name || item.name);

  if (!newName) {
    renameError.value = "Enter a name before saving.";
    return;
  }
  if (newName.length > FEATURE_NAME_MAX_LENGTH) {
    renameError.value = `Keep the feature name to ${FEATURE_NAME_MAX_LENGTH} characters or fewer.`;
    return;
  }
  if (newName === existingName) {
    cancelNameEdit();
    return;
  }

  nameSaveInFlight.value = true;
  renameError.value = "";
  try {
    await featureStore.updateFeatureName(item.instance_id, newName);
    editingSlug.value = null;
    editNameField.value = "";
  } catch (error) {
    renameError.value = error?.message || "The feature name could not be saved. Try again.";
  } finally {
    nameSaveInFlight.value = false;
  }
};

const togglePublish = async (feature) => {
  if (!feature) return;

  const updatedValue = feature.is_published ? 0 : 1;

  try {
    const response = await fetch(`${apiProxyUrl}/api/feature-instances/${feature.instance_id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        isPublished: updatedValue,
        isPaywalled: feature.is_paywalled ?? 0,
        isHidden: feature.is_hidden ?? 0,
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || `Feature update failed (${response.status})`);
    }

    // Update local store (keeps UI synced)
    await featureStore.fetchFeatureInstances();

    // Update drawer reference
    selectedFeatureForSettings.value = applyFeaturePricingDefaults(
      findFeatureByInstanceId(feature.instance_id) || {
        ...feature,
        is_published: updatedValue,
      }
    );

  } catch (err) {
    console.error("Failed to toggle publish:", err);
  }
};

const toggleIncognito = async (feature) => {
  if (!feature) return;

  const updatedValue = feature.is_hidden ? 0 : 1;

  try {
    const response = await fetch(`${apiProxyUrl}/api/feature-instances/${feature.instance_id}/incognito`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        isIncognito: updatedValue,
      }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data?.success === false) {
      throw new Error(data?.message || `Incognito update failed (${response.status})`);
    }

    await featureStore.fetchFeatureInstances();

    selectedFeatureForSettings.value = applyFeaturePricingDefaults(
      findFeatureByInstanceId(feature.instance_id) || {
        ...feature,
        is_hidden: updatedValue,
      }
    );
  } catch (err) {
    console.error("Failed to toggle incognito:", err);
  }
};

const openFeaturePaywallPageEditor = (feature) => {
  const pageId = Number.parseInt(String(feature?.paywall_page_id || 0), 10) || 0;
  if (!pageId) return;
  inlineFeaturePaywallEditor.value = {
    pageId,
    featureSlug: String(feature?.slug || route.params.featureSlug || '').trim(),
    featureInstanceId: Number.parseInt(String(feature?.instance_id || 0), 10) || 0,
  };
};

const saveFeaturePricing = async (feature) => {
  if (!feature || featurePricingSaveBusy.value) return;
  const featureId = Number.parseInt(String(feature?.instance_id || 0), 10) || 0;
  if (!featureId) return;
  const isPaywalled = Number(feature?.is_paywalled) ? 1 : 0;
  const paywallPriceCents = toPaywallCents(feature?.paywall_price_dollars);
  if (isPaywalled && paywallPriceCents < 50) {
    featurePricingSaveError.value = true;
    featurePricingSaveMessage.value = 'Feature price must be at least $0.50 when pricing is enabled.';
    return;
  }

  featurePricingSaveBusy.value = true;
  featurePricingSaveError.value = false;
  featurePricingSaveMessage.value = '';
  try {
    const response = await fetch(`${apiProxyUrl}/api/feature-instances/${featureId}`, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        isPublished: Number(feature?.is_published) ? 1 : 0,
        isPaywalled,
        isHidden: Number(feature?.is_hidden) ? 1 : 0,
        paywallBillingCadence: normalizeFeaturePaywallCadenceValue(feature?.paywall_billing_cadence),
        paywallPriceCents,
        paywallCurrencyCode: 'USD',
        paywallProvider: normalizeFeaturePaywallProviderValue(feature?.paywall_provider),
        paywallPageId: Number.parseInt(String(feature?.paywall_page_id || 0), 10) || null,
      }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload?.success === false) {
      throw new Error(String(payload?.message || payload?.error || 'Failed to save feature pricing'));
    }

    await featureStore.fetchFeatureInstances();
    const refreshed = applyFeaturePricingDefaults(findFeatureByInstanceId(featureId) || {
      ...feature,
      ...(payload?.feature || {}),
      paywall_price_cents: paywallPriceCents,
      paywall_price_dollars: toPaywallDollars(paywallPriceCents),
    });
    selectedFeatureForSettings.value = refreshed;
    featurePricingSaveError.value = false;
    featurePricingSaveMessage.value = 'Feature pricing saved.';
  } catch (error) {
    console.error('Failed to save feature pricing:', error);
    featurePricingSaveError.value = true;
    featurePricingSaveMessage.value = String(error?.message || 'Failed to save feature pricing');
  } finally {
    featurePricingSaveBusy.value = false;
  }
};

const toggleFeaturePricing = async (feature) => {
  const source = feature && typeof feature === 'object'
    ? feature
    : selectedFeatureForSettings.value;
  if (!source || typeof source !== 'object') return;
  const next = Number(source?.is_paywalled) ? 0 : 1;
  const sourceInstanceId = Number.parseInt(String(source?.instance_id || 0), 10) || 0;
  if (next === 0 && sourceInstanceId) {
    const editingInstanceId = Number.parseInt(String(inlineFeaturePaywallEditor.value?.featureInstanceId || 0), 10) || 0;
    if (editingInstanceId === sourceInstanceId) {
      closeInlineFeaturePaywallEditor();
    }
  }
  selectedFeatureForSettings.value = applyFeaturePricingDefaults({
    ...source,
    is_paywalled: next,
  });
  // Turning paywall off should save immediately.
  if (next === 0) {
    await saveFeaturePricing(selectedFeatureForSettings.value);
    return;
  }
  featurePricingSaveError.value = false;
  featurePricingSaveMessage.value = 'Set your price and click Save Pricing to enable this paywall.';
};

const saveNavigationOrder = async () => {
  // Build payload of instance_id + new order
  const ordered = navigation.value
    .filter(item => item.instance_id && item.instance_id !== -1)
    .map((item, index) => ({
      instance_id: item.instance_id,
      navigation_order: index + 1
    }));

  try {
    await fetch(`${apiProxyUrl}/api/feature-instances/reorder`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ordered),
    });

    console.log("Navigation order saved:", ordered);

    // Refresh store to keep everything synced
    await featureStore.fetchFeatureInstances();

    fetchFeatures();

  } catch (err) {
    console.error("Failed to save navigation order:", err);
  }
};

// 🔥 When the route changes, update the drawer content automatically
watch(
  () => route.params.featureSlug,
  (newSlug) => {
    if (!newSlug) return;

    // Find feature from store
    const feature = featureStore.state.featureInstances.find(
      (f) => f.slug === newSlug
    );

    // If drawer is open → update content instantly
    if (settingsDrawerOpen.value && feature) {
      selectedFeatureForSettings.value = applyFeaturePricingDefaults(feature);
    }
  }
);

watch(
  () => route.fullPath,
  async (newPath, oldPath) => {
    if (newPath === oldPath) return;
    if (!String(newPath || '').startsWith('/creator/theme-editor')) {
      closeInlineFeaturePaywallEditor();
      return;
    }
    const activeSlug = String(route.params.featureSlug || '').trim();
    const editingSlug = String(inlineFeaturePaywallEditor.value?.featureSlug || '').trim();
    if (editingSlug && activeSlug && editingSlug !== activeSlug) {
      closeInlineFeaturePaywallEditor();
    }
    await featureStore.fetchFeatureInstances();
    fetchFeatures();
  }
);

const faviconInput = ref(null);
const faviconPreview = ref(require('@/assets/media/images/platformalogostack.png'));
const faviconExample = ref(require('@/assets/media/images/app_favicon_description.png'));

const seoTitle = ref('');
const seoDescription = ref('');
const membershipName = ref('');

const triggerFaviconUpload = () => {
  faviconInput.value.click();
};

const updateFavicon = async (event) => {
  const file = event.target.files[0];
  if (!file) return;

  // Preview
  const reader = new FileReader();
  reader.onload = (e) => {
    faviconPreview.value = e.target.result;
  };
  reader.readAsDataURL(file);

  uploadingFavicon.value = true;
  globalSettingsFeedback.value = null;
  try {
    const response = await fetch(`${apiProxyUrl}/api/favicon`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": file.type },
      body: file,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || !payload?.favicon_url) {
      throw new Error(payload?.message || payload?.error || 'Unable to upload the favicon.');
    }

    appSettingsStore.settings = {
      ...(appSettingsStore.settings || {}),
      favicon_url: payload.favicon_url,
      updated_at: new Date().toISOString(),
    };
    await appSettingsStore.fetchFavicon();
    faviconPreview.value = `${appSettingsStore.favicon}&t=${Date.now()}`;
    globalSettingsFeedback.value = {
      type: 'success',
      message: 'Favicon uploaded. The member app will use the new icon on its next page load.',
    };
  } catch (error) {
    globalSettingsFeedback.value = {
      type: 'error',
      message: error?.message || 'Unable to upload the favicon.',
    };
  } finally {
    uploadingFavicon.value = false;
    event.target.value = '';
  }
};



const currentThemeSettingsPayload = () => ({
  membershipName: membershipName.value,
  seoTitle: seoTitle.value,
  seoDescription: seoDescription.value,
  navBgColor: sidebarBgColor.value,
  textIconColor: textIconColor.value,
  textIconHoverColor: textIconHoverColor.value,
  productHoverColor: productHoverColor.value,
});

const persistCurrentThemeSettings = () => (
  appSettingsStore.saveSettings(currentThemeSettingsPayload())
);

const publishCurrentMemberThemeSelection = async () => {
  const response = await fetch(`${apiProxyUrl}/api/app-settings/theme`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ themeKey: activeMemberThemeKey.value }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.message || payload?.error || 'Unable to publish the active theme.');
  }
  return payload;
};

const setThemeActionFeedback = (message, type = 'success') => {
  if (themeActionFeedbackTimer) clearTimeout(themeActionFeedbackTimer);
  themeActionFeedback.value = { message, type };
  showTaskbar.value = true;
  themeActionFeedbackTimer = setTimeout(() => {
    themeActionFeedback.value = null;
    themeActionFeedbackTimer = null;
    if (!taskbarHovered.value) showTaskbar.value = false;
  }, 4000);
};

const saveThemeFromTaskbar = async () => {
  if (themeSettingsBusy.value) return;
  themeActionBusy.value = 'save';
  themeActionFeedback.value = null;
  try {
    await persistCurrentThemeSettings();
    setThemeActionFeedback('Theme changes saved.');
  } catch (error) {
    setThemeActionFeedback(error?.message || 'Unable to save the theme.', 'error');
  } finally {
    themeActionBusy.value = '';
  }
};

const publishThemeFromTaskbar = async () => {
  if (themeSettingsBusy.value) return;
  themeActionBusy.value = 'publish';
  themeActionFeedback.value = null;
  try {
    await persistCurrentThemeSettings();
    await publishCurrentMemberThemeSelection();
    await appSettingsStore.fetchSettings();
    setThemeActionFeedback('Theme published and live for members.');
  } catch (error) {
    setThemeActionFeedback(error?.message || 'Unable to publish the theme.', 'error');
  } finally {
    themeActionBusy.value = '';
  }
};

const saveGlobalAppSettings = async () => {
  if (themeSettingsBusy.value) return;
  globalSettingsSaving.value = true;
  globalSettingsFeedback.value = null;
  try {
    await persistCurrentThemeSettings();
    globalSettingsFeedback.value = {
      type: 'success',
      message: 'Global app settings saved.',
    };
  } catch (error) {
    globalSettingsFeedback.value = {
      type: 'error',
      message: error?.message || 'Unable to save global app settings.',
    };
  } finally {
    globalSettingsSaving.value = false;
  }
};

const applySettings = (s) => {
  if (!s) return;


  if (!uploadingFavicon.value && s.favicon_url) {
  faviconPreview.value = s.favicon_url;
 }

  sidebarBgColor.value     = s.nav_bg_color        || '#1f2937';
  textIconColor.value      = s.text_icon_color     || '#a1a1aa';
  textIconHoverColor.value = s.text_icon_hover_color || '#f4f4f5';
  productHoverColor.value  = s.product_hover_color || '#27272a';

  membershipName.value = s.membership_name || '';
  seoTitle.value       = s.seo_title       || '';
  seoDescription.value = s.seo_description || '';
};



watch(
  () => appSettingsStore.settings,
  (settings) => {
    console.log("👀 [LAYOUT] store settings changed:", settings);
    console.log("👀 WATCH TRIGGERED — settings:", settings);

    if (!settings) return;

    // ❗ IMPORTANT: still apply all other settings
    applySettings(settings);
  },
  { immediate: true }
);

watch(
  () => appSettingsStore.favicon,
  (newUrl) => {
    if (!newUrl) return;
    if (!uploadingFavicon.value) {
      faviconPreview.value = `${newUrl}?t=${Date.now()}`;
    }
  },
  { immediate: true }
);


// Fetch features and set up navigation on component mount
onMounted(async () => {
  // features
  await featureStore.fetchFeatureInstances();
  fetchFeatures();

  // settings (watcher will apply them)
  await appSettingsStore.fetchSettings();
  await appSettingsStore.fetchLogo();
  logoSrc.value = appSettingsStore.logo;

  await appSettingsStore.fetchFavicon();

if (appSettingsStore.favicon) {
  faviconPreview.value = `${appSettingsStore.favicon}?t=${Date.now()}`;
}

  window.addEventListener('mousemove', checkMousePosition);
  window.addEventListener("mousedown", handleClickOutside);
  window.addEventListener('platforma:flix-sidebar', handleFlixSidebarRequest);
  window.addEventListener('platforma:flix-layout-state-request', handleFlixLayoutStateRequest);
  emitFlixLayoutState();
});

onUnmounted(() => {
  clearFlixSidebarTimer();
  if (themeActionFeedbackTimer) clearTimeout(themeActionFeedbackTimer);
  window.removeEventListener('mousemove', checkMousePosition);
  window.removeEventListener("mousedown", handleClickOutside);
  window.removeEventListener('platforma:flix-sidebar', handleFlixSidebarRequest);
  window.removeEventListener('platforma:flix-layout-state-request', handleFlixLayoutStateRequest);
});


// Mouse position listener to show/hide the taskbar
const checkMousePosition = (e) => {
  if (taskbarHovered.value || themeActionBusy.value || themeActionFeedback.value) {
    showTaskbar.value = true;
    return;
  }
  showTaskbar.value = window.innerHeight - e.clientY < 64;
};

const holdTaskbarOpen = () => {
  taskbarHovered.value = true;
  showTaskbar.value = true;
};

const releaseTaskbar = () => {
  taskbarHovered.value = false;
  if (themeActionBusy.value || themeActionFeedback.value) {
    showTaskbar.value = true;
    return;
  }
  showTaskbar.value = false;
};


onUnmounted(() => {
  clearFlixSidebarTimer();
  window.removeEventListener('mousemove', checkMousePosition);
  window.removeEventListener("mousedown", handleClickOutside);
  window.removeEventListener('platforma:flix-sidebar', handleFlixSidebarRequest);
  window.removeEventListener('platforma:flix-layout-state-request', handleFlixLayoutStateRequest);
});


</script>


<style scoped>


/* Slide up transition for the taskbar */
.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease;
}
.slide-up-enter-from, .slide-up-leave-to {
  transform: translateY(100%);
}

----- Modal Fade Transition -----
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Creator layout scrollbar (right column only) */
.app-scroll {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  scrollbar-gutter: stable;
}

.app-scroll::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.app-scroll::-webkit-scrollbar-button {
  display: none;
  width: 0;
  height: 0;
  background: transparent;
}

.app-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.app-scroll::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 999px;
}

.app-scroll:hover {
  scrollbar-color: rgba(145, 150, 156, 0.541) transparent;
}

.app-scroll:hover::-webkit-scrollbar-thumb {
  background-color: rgba(140, 143, 148, 0.479);
}

.app-scroll:hover::-webkit-scrollbar-thumb:hover {
  background-color: rgba(203, 213, 225, 0.65);
}

</style>


